import api from "./axios";

export const getHarvestCandidates = async () => {
  const res = await api.get("/api/tax/harvest-candidates/");
  return res.data;
};
